import {
  fetchingNetSuiteAssets,
  fetchingNetSuiteAssetsSuccess,
  fetchingNetSuiteAssetsError,
  fetchingNetSuiteAssetsMe,
  fetchingNetSuiteAssetsMeSuccess,
  fetchingNetSuiteAssetsMeError,
  assigningNetSuiteAsset,
  assigningNetSuiteAssetError,
  assigningNetSuiteAssetSuccess,
} from './actions'
import { get } from 'lodash'
import { actions as notificationActions } from 'store/notificationsManager'
import { LICENSE_ASSIGNMENT_FAILURE_TEXT } from './constants'
import secondStepApiV4 from 'lib/api/secondStepApiV4'
import { push } from 'connected-react-router'

export const normalizeNetSuiteAssetsResponse = data => {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.data)) return data.data
  if (Array.isArray(data?.netSuiteAssets)) return data.netSuiteAssets
  return []
}

export const getNetSuiteAssetsMe = () => {
  return async dispatch => {
    dispatch(fetchingNetSuiteAssetsMe())
    try {
      const response = await secondStepApiV4.getNetSuiteAssetsMe()
      dispatch(
        fetchingNetSuiteAssetsMeSuccess(
          normalizeNetSuiteAssetsResponse(response.data),
        ),
      )
    } catch (error) {
      dispatch(fetchingNetSuiteAssetsMeError(error))
    }
  }
}

export const getNetSuiteAssets = () => {
  return async dispatch => {
    dispatch(fetchingNetSuiteAssets())
    try {
      const response = await secondStepApiV4.getNetSuiteAssets()
      dispatch(fetchingNetSuiteAssetsSuccess(response.data))
    } catch (error) {
      dispatch(fetchingNetSuiteAssetsError(error))
    }
  }
}

export const assignNetSuiteAsset = (assetId, params) => {
  return async dispatch => {
    dispatch(assigningNetSuiteAsset())
    try {
      const response = await secondStepApiV4.updateNetSuiteAsset(
        assetId,
        params,
      )
      dispatch(
        notificationActions.addNotification({
          color: 'success',
          text: "You've successfully assigned a product license to this school",
        }),
      )
      dispatch(assigningNetSuiteAssetSuccess(response.data))
      dispatch(push('/license-management'))
    } catch (error) {
      dispatch(assigningNetSuiteAssetError(error))
      const errorText =
        get(error, 'response.data') || LICENSE_ASSIGNMENT_FAILURE_TEXT
      dispatch(
        notificationActions.addNotification({
          color: 'danger',
          text: errorText,
        }),
      )
      dispatch(push('/license-management'))
    }
  }
}
